/**
 * Extracts unique filter values for a given key from a list of items.
 * If the item value is an object with `props.state`, uses that; otherwise stringifies the value.
 * Filters out null, undefined, empty strings, and "null"/"undefined" string values.
 *
 * @param key - The object key to extract.
 * @param list - Array of items to filter.
 * @returns An array of unique string values.
 */
export function getFilterValues<T extends Record<string, any>>(
  key: keyof T,
  list: T[],
): string[] {
  const values = list
    .map((item) => {
      const val = item[key];
      if (
        val &&
        typeof val === "object" &&
        "props" in val &&
        typeof val.props?.state === "string"
      ) {
        return val.props.state;
      }
      return val != null ? String(val) : null;
    })
    .filter((val): val is string => val !== null && val !== "" && val !== "null" && val !== "undefined");
  return Array.from(new Set(values));
}

export default getFilterValues;
